export default __webpack_public_path__ + "static/media/ios_icon.dc82e13d.svg";